(function () {
  if (window.smartPotWholesaleHub) return;
  window.smartPotWholesaleHub = true;
  const pushEvent = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...details });
  };
  const updateAudience = () => {
    const form = document.getElementById('WholesaleInquiryForm');
    if (!form) return;
    const value = form.elements['contact[Business type]'].value;
    const audience = /Retailer|Distributor/.test(value) ? 'retail' : /grower|nursery|Greenhouse|Landscape/.test(value) ? 'grower' : 'default';
    form.querySelectorAll('[data-wholesale-submit], [data-wholesale-purpose]').forEach(el => {
      el.textContent = el.dataset[audience];
    });
  };
  const setBusinessType = value => {
    const select = document.querySelector('#WholesaleInquiryForm select[name="contact[Business type]"]');
    if (!select || !Array.from(select.options).some(option => option.value === value)) return;
    select.value = value;
    updateAudience();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-wp-event]');
    if (!link) return;
    if (link.dataset.businessType) setBusinessType(link.dataset.businessType);
    pushEvent(link.dataset.wpEvent, { audience: link.dataset.businessType || '', placement: link.dataset.wpPlacement || '', link_url: link.getAttribute('href') || '' });
    if (link.getAttribute('href') === '#wholesale-inquiry') {
      const select = document.querySelector('#WholesaleInquiryForm select');
      requestAnimationFrame(() => {
        select?.focus({ preventScroll: true });
        if (window.matchMedia('(max-width: 749px)').matches) {
          select?.closest('.wp-inquiry__form-wrap').scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      });
    }
  });
  document.addEventListener('change', event => {
    if (event.target.name === 'contact[Business type]') updateAudience();
  });
  document.addEventListener('submit', event => {
    if (event.target.id === 'WholesaleInquiryForm') pushEvent('wholesale_inquiry_submit', { form_id: 'WholesaleInquiryForm', audience: event.target.elements['contact[Business type]'].value });
  });
  const init = () => {
    setBusinessType(new URLSearchParams(location.search).get('audience'));
    updateAudience();
    const success = document.querySelector('[data-wholesale-inquiry-success]');
    if (success && !success.dataset.tracked) {
      success.dataset.tracked = 'true';
      pushEvent('wholesale_inquiry_success', { form_id: 'WholesaleInquiryForm' });
      success.focus();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
